/**
 * Compares two versions in the format "major.minor.patch".
 * @param version1 The first version.
 * @param version2 The second version.
 * @returns 1 if version1 is greater than version2, -1 if version1 is less than version2, and 0 if they are equal.
 */
export function compareVersions(manifestVersion: string, currentVersion: string): number {
    const manifestVersionParts = manifestVersion.split('.').map(Number);
    const currentVersionParts = currentVersion.split('.').map(Number);
    if(manifestVersionParts[0] === currentVersionParts[0] && manifestVersionParts[1] === currentVersionParts[1]){
        if(manifestVersionParts[2] !== currentVersionParts[2]){
            return 1
        }
    }
    return -1;
}
